"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _icons = require("../../toolkit/icons");

var _localization = require("../../toolkit/localization");

//
//  src/button/ViewButton.tsx
//  Project-Lego
//
//  Created by Mengyu Yuan on 1/30/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Lego Components */

/* Lego Toolkit */
var propDoc = _lodash["default"].omit(_IconButton["default"].propDoc, ["icon"]);

var demoProps = {
  onClick: function onClick() {}
};
var discussion = "\n  This component wraps [`IconButton`](/lego/component/IconButton).\n";

var ViewButton = function ViewButton(props) {
  var popoverContent = props.popoverContent,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["popoverContent", "children"]);

  var _useLocalization = (0, _localization.useLocalization)(),
      i18n = _useLocalization.i18n; // allow user to set popoverContent to empty string


  var tip = popoverContent == undefined ? i18n("View") : popoverContent;
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
    popoverContent: tip,
    icon: _icons.eye
  }, otherProps), children);
};

ViewButton.propDoc = propDoc;
ViewButton.demoProps = demoProps;
ViewButton.discussion = discussion;
var _default = ViewButton;
exports["default"] = _default;